import React, { useEffect, useState } from 'react';
import { Navigate, Outlet, useNavigate } from 'react-router-dom';
import { isAuthenticated } from './authUtils';

function PrivateRoute(props) {
  const navigate = useNavigate();
  const { component: Component, ...rest } = props; 
  const [isAuth, setIsAuth] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkAuth = () => {
      try {
        const authenticated = isAuthenticated();
        setIsAuth(authenticated);
        setIsLoading(false);
        
        if (!authenticated) {
          navigate('/login');
        }
      } catch (error) {
        console.error('Error checking authentication:', error);
        setIsAuth(false);
        setIsLoading(false);
        navigate('/login');
      }
    };

    checkAuth();
  }, [navigate]);

  if (isLoading) {
    return <div>Loading...</div>; // You can replace this with a proper loading component
  }

  return isAuth ? <Component {...rest} /> : null;
}

export default PrivateRoute;

